import { render, staticRenderFns } from "./ReviewableRenderer.vue?vue&type=template&id=1cc45f2c&"
import script from "./ReviewableRenderer.vue?vue&type=script&lang=js&"
export * from "./ReviewableRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports